export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    tem_descripcion: item.tem_descripcion || "Temporada no disponible",
    tem_fechainicio: item.tem_fechainicio || "Fecha de inicio no disponible",
    tem_fechafin: item.tem_fechafin || "Fecha de fin no disponible",
  }));
